import { useEffect, useState } from 'react';
export function useKeyPress(targetKey) {
    const [keyPressed, setKeyPressed] = useState(false);
    useEffect(() => {
        function keyDownHandler({ key }) {
            if (key === targetKey) {
                setKeyPressed(true);
            }
        }
        function keyUpHandler({ key }) {
            if (key === targetKey) {
                setKeyPressed(false);
            }
        }
        window.addEventListener('keydown', keyDownHandler);
        window.addEventListener('keyup', keyUpHandler);
        return () => {
            window.removeEventListener('keydown', keyDownHandler);
            window.removeEventListener('keyup', keyUpHandler);
        };
    }, [targetKey]);
    // Avoid triggering a related callback multiple times depending on the rendering order
    function onKeyPressHandled() {
        setKeyPressed(false);
    }
    return [keyPressed, onKeyPressHandled];
}
